import React from "react";
// import icon from "../images/programming.png";
function Card({icon,title}) {
  return (
    <div className="flex flex-col justify-center items-center gap-2 w-full md:w-[30%]">
      <img src={icon} width={70}/>
      <span className="font-semibold text-[1.5rem]">{title}</span>
      <p className="" style={{color:'rgb(108, 117, 125)'}}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Non autem
        ratione, voluptatibus provident quos in nulla sequi iste quisquam
        consectetur unde beatae ullam iure enim consequuntur voluptatum? Est,
        sunt iusto.
      </p>
    </div>
  );
}

export default Card;
